<template>
    <div>
        <v-icon :color="color" v-if="property.propertyType == 'Flat'">
            mdi-office-building
        </v-icon>

        <v-icon :color="color" v-else>
            mdi-home
        </v-icon>

        <v-icon v-if="wheelchairAccessible" :color="color">
            mdi-wheelchair-accessibility
        </v-icon>
    </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
    name: 'TypeIcons',
    props: {
        property: {
            type: Object,
            required: true
        },
        color: {
            type: String,
            required: false,
            default: 'primary'
        },
        wheelchairAccessible: {
            type: Boolean,
            required: true
        }
    },
    setup() {
        
    },
})
</script>
